export default __webpack_public_path__ + "static/media/estamos_buscando.1be8c934.svg";